import React, { PropsWithChildren } from 'react';
import { AnimatePresence } from 'motion/react';
import * as motion from 'motion/react-m';

import { bg1, bg2 } from '@osmosis/tailwind-ui/styles/background';
import { textGray500 } from '@osmosis/tailwind-ui/styles/text';
import { Box } from '@osmosis/tailwind-ui/components/Box';
import { Flex } from '@osmosis/tailwind-ui/components/Box';
import { Icon } from '@osmosis/tailwind-ui/components/Icon';
import { H4 } from '@osmosis/tailwind-ui/components/Text';
import { faAngleDown } from '@fortawesome/pro-solid-svg-icons/faAngleDown';
import { faAngleUp } from '@fortawesome/pro-solid-svg-icons/faAngleUp';

import { ModalHookProps } from '../../hooks/useModal';

type Props = PropsWithChildren & {
  modalProps: ModalHookProps;
  name: string;
};

/**
 * Dropdown wrapper for the topics item in mobile view.
 */
const TopicsItemDropdownWrapper = (props: Props) => {
  const { children, modalProps, name } = props;
  const { setIsVisible, isVisible } = modalProps;

  const bgColors = `${bg1} hover:${bg2}`;
  return (
    <Box className="py-2 text-blue-100">
      <Flex
        data-testid="topics-item-dropdown-wrapper"
        onClick={() => setIsVisible(!isVisible)}
        className={`p-2 w-full flex justify-between items-center rounded-[5px] ursor-pointer transition-all duration-100 ease-in-out ${bgColors}`}
      >
        <H4>{name}</H4>
        <Icon
          className={`text-sm font-bold ${textGray500}`}
          icon={isVisible ? faAngleUp : faAngleDown}
        />
      </Flex>
      <AnimatePresence>
        <motion.div
          style={{ overflow: 'hidden' }}
          transition={{ duration: 0.5 }}
          initial={{ height: 0 }}
          animate={{
            height: isVisible ? 'auto' : 0,
          }}
        >
          <Box className="overflow-y-scroll overflow-x-hidden w-full max-h-[432px]">
            {children}
          </Box>
        </motion.div>
      </AnimatePresence>
    </Box>
  );
};

export default TopicsItemDropdownWrapper;
